import { type ObjectValuesUnionType } from '../../../utils/typing';

export const KLNotificationTypes = Object.freeze({
  BADGE_WON: 'BADGE_WON',
  BADGE_LOST: 'BADGE_LOST',
  VOTE_PENALTY: 'VOTE_PENALTY',
  COLLAR_WON: 'COLLAR_WON',
  COLLAR_LOST: 'COLLAR_LOST',
  COLLAR_USED: 'COLLAR_USED',
  COMFORT_WON: 'COMFORT_WON',
  COMFORT_LOST: 'COMFORT_LOST',
  MARK_WON: 'MARK_WON',
  MARK_LOST: 'MARK_LOST',
  TAG_WON: 'TAG_WON',
  TAG_LOST: 'TAG_LOST',
  KNIFE_WON: 'KNIFE_WON',
  KNIFE_LOST: 'KNIFE_LOST',
  KNIFE_MISS: 'KNIFE_MISS',
  POLE_BET_LOST: 'POLE_BET_LOST',
  POLE_BET_WON: 'POLE_BET_WON',
  PRICE_WON: 'PRICE_WON',
  ROUND_COMPLETE: 'ROUND_COMPLETE',
  TORCH: 'TORCH',
  FALL: 'FALL',
});
export type KLNotificationType = ObjectValuesUnionType<typeof KLNotificationTypes>;
